import { Auth } from 'aws-amplify';
import { AbstractApiService, TokenProvider } from 'shared/services/abstractApiService';

interface Config {
  endpoint: string;
}

class PartnerTokenProvider implements TokenProvider {
  public async currentToken(): Promise<string> {
    const session = await Auth.currentSession();
    return session.getAccessToken().getJwtToken();
  }
}

export class PartnerApiService extends AbstractApiService {
  constructor(config: Config) {
    super(config.endpoint, new PartnerTokenProvider());
  }

  public getHeaders() {
    const partnerHash = window.location.pathname.split('/')[2];

    return {
      ...super.getHeaders(),
      CompanyId: partnerHash,
    };
  }
}
